<template>

  <div class="apply-school">
    <div class="show-wapper">
      <div>
        <div class="main-wrap">
          <div id="main-content" >
            <div class="wrapper">
              <div class="table-agile-info">
                <jm-crumbs :crm_id="this.$route.params.id"/>
                <div class="information">
                  <div class="information-left">
                    <a
                      v-if="canSave()"
                      :href="`/frontend/log/contduct/${editData.crm_id}/offer`"
                      class="lookHis"
                      target="_blank">
                      <span>查看操作历史</span>
                    </a>
                  </div>
                  <div class="information-right">
                    <el-alert
                      v-if="editData.userid"
                      show-icon
                      type="success"
                      :title="`该学生注册号：(${editData.tel})`"
                      description="请指导学生使用该手机号登录芥末网（https://www.jiemo.net）
                        或下载芥末留学APP（https://app.jiemo.net），查看并确认择校规划单。">
                    </el-alert>
                    <el-alert
                      v-else
                      show-icon
                      type="error"
                      title="尚未注册，请联系学生用系统中对应手机号码注册芥末网"
                      description="然后指导学生使用该手机号登录芥末网（https://www.jiemo.net）
                          或下载芥末留学APP（https://app.jiemo.net），查看并确认择校规划单。">
                    </el-alert>
                  </div>
                </div>
                <div class="basic-title"><em style="font-size:26px">择校订单</em></div>
                <div class="tit-wapper">
                  <div class="jm-fl">
                    <span>基本情况</span>
                  </div>
                </div>
                <div class="ipt-wapper">
                  <!--基础信息以英国为基准 根据offer_hope_country是否添加特殊字段-->
                  <div class="readonly-info-wrap" >
                    <el-row>
                      <el-col :span="2">
                        <i class="annotation">*</i>学生姓名:
                      </el-col>
                      <el-col :span="5">
                        <el-input
                          class="jm-input-common4"
                          v-model="editData.custom_name"
                          placeholder="学生姓名"
                          v-validate="'required'"
                          :readonly="true"
                          name="stuname"/>
                      </el-col>
                      <el-col :span="4">
                        <span class="errors" v-if="errors.has('stuname')">* {{ errors.first('stuname') }}</span>
                      </el-col>
                      <el-col :span="2">
                        <i class="annotation">*</i>办理国家:
                      </el-col>
                      <el-col :span="11">
                        <span v-for="item in CountriesNames" :key="item.id">{{ item.name }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">
                        <i class="annotation">*</i>学历:
                      </el-col>
                      <el-col :span="5">
                        <jm-dict-select
                          :disabled="editData.is_queren === 2 || editData.is_queren === 4"
                          v-validate="'customEducation'"
                          name="customEducation"
                          :visible.sync="visible"
                          v-model="editData.custom_education"
                          :show="true"
                          dict-type="education"/>
                        <jm-dict-select
                          :disabled="editData.is_queren === 2 || editData.is_queren === 4"
                          v-show="editData.custom_education === 4"
                          clearable
                          v-model="editData.arts_science"
                          type="jiemo"
                          value-type="string"
                          empty-label="请选择"
                          dict-type="arts_science"/>
                      </el-col>
                      <el-col :span="4">
                        <span class="errors" v-if="errors.has('customEducation')">* {{ errors.first('customEducation') }}</span>
                      </el-col>
                      <el-col :span="2">
                        学历备注:
                      </el-col>
                      <el-col :span="7">
                        <el-input
                          :readonly="true"
                          name="xueliBz"
                          class="jm-input-common"
                          v-model="editData.xueli_bz"
                          placeholder="请输入内容"/>
                      </el-col>
                      <el-col :span="4">
                        <span class="errors" v-if="errors.has('xueliBz')">* {{ errors.first('xueliBz') }}</span>
                      </el-col>
                    </el-row>
                    <!--澳大利亚特殊字段-->
                    <el-row v-if="editData.offer_hope_country === 31 || editData.offer_hope_country === 673">
                      <el-col :span="2">
                        工作经验:
                      </el-col>
                      <el-col :span="5">
                        <el-checkbox v-model="experience"/>
                      </el-col>
                      <el-col :span="2">
                        年限:
                      </el-col>
                      <el-col :span="6">
                        <el-input :disabled="!experience" v-model="editData.work_year" placeholder="年限"/>
                      </el-col>
                      <el-col :span="2">
                        职位:
                      </el-col>
                      <el-col :span="7">
                        <el-input :disabled="!experience" v-model="editData.position" placeholder="职位"/>
                      </el-col>
                    </el-row>
                  </div>
                  <!--基础信息end 毕业学校信息有两种高中及以下 和 高中以上-->
                  <div v-if="editData.custom_education > 4">
                    <el-radio-group v-model="isRadio">
                      <jm-school
                        v-for="(num, index) in gschoolList"
                        :is-radios.sync="isRadio"
                        :key="num.id"
                        :school-num="index"
                        :crm-id="editData.crm_id"
                        :obj.sync="num"
                        :schoolarr.sync="gschoolList"
                        :is-read-only="true"
                        :can-save="canSave()"/>
                    </el-radio-group>
                  </div>
                  <div
                    class="highSchool"
                    v-if="editData.custom_education <= 4">
                    <div class="mes-wapper">
                      <span><i class="annotation">*</i>毕业学校:</span>
                      <el-input
                        size="small"
                        v-validate="'required'"
                        name="highGschool"
                        v-model="gschoolList[0].school"
                        placeholder="请输入学校"
                        style="width: 300px"/>
                      <span
                        class="errors"
                        v-if="errors.has('highGschool')">* {{ errors.first('highGschool') }}</span>
                    </div>
                    <div
                      class="school-mes"
                      style="display: flex;align-items: center;margin: 8px;">
                      <div class="mes-wapper sp">
                        <span style="padding: 0"><i class="annotation">*</i>GPA分数:</span>
                      </div>
                      <div class="mes-wapper jm-fl">
                        <el-input
                          size="small"
                          v-validate="'between:0,100|decimal:2'"
                          name="allsuanshu"
                          @blur="jidian(editData.gpa_suanshu, editData.gpa_jidian, index)"
                          v-model="editData.gpa_suanshu"
                          placeholder="算数平均分"/>
                      </div>
                      <div class="mes-wapper jm-fl">
                        <el-input
                          size="small"
                          v-validate="'between:0,100|decimal:2'"
                          name="alljiaquan"
                          v-model="editData.gpa_jiaquan"
                          placeholder="加权平均分"/>
                      </div>
                      <div class="mes-wapper jm-fl">
                        <el-input
                          size="small"
                          v-validate="'between:0,4|decimal:2'"
                          name="alljidian"
                          @blur="suanshu(editData.gpa_jidian, editData.gpa_suanshu, index)"
                          v-model="editData.gpa_jidian"
                          placeholder="绩点"/>
                      </div>
                      <el-tooltip placement="right">
                        <div slot="content" style="width:150px">包括所有课程的成绩（含选修），只要是成绩单上的课程都要计算。</div>
                        <el-button class="help-button">?</el-button>
                      </el-tooltip>

                      <!-- GPA 成绩错误提示 -->
                      <div class="gpaTips">
                        <p>
                          <span class="errors" v-if="editData.gpa_suanshu === '' && editData.gpa_jiaquan === '' && editData.gpa_jidian === ''">
                            * GPA项目至少添加一项
                          </span>
                        </p>
                        <p><span class="errors" v-if="errors.has('allsuanshu')" >* {{ errors.first('allsuanshu') }}</span></p>
                        <p><span class="errors" v-if="errors.has('alljiaquan')" >* {{ errors.first('alljiaquan') }}</span></p>
                        <p><span class="errors" v-if="errors.has('alljidian')" >* {{ errors.first('alljidian') }}</span></p>
                      </div>
                    </div>

                    <div class="float" v-if="!editData.id">
                      <p>需优先点击“提交保存”，方可同步毕业院校信息</p>
                    </div>
                  </div>
                  <div class="ipt add">
                    <div class="fenshu-wapper" >
                      <div class="fenshu">
                        <div class="ielts" v-if="haslanguage('IELTS')">
                          <span>IELTS  :</span>
                          <el-input v-validate="'between:0,9|IELTS'" name="IELTSlnAll" v-model="editData.ln_score.IELTS.ln_all" placeholder="总分"/>
                          L  :<el-input v-validate="'between:0,9|IELTS'" name="IELTSlnListen" v-model="editData.ln_score.IELTS.ln_listen" placeholder="L"/>
                          R  :<el-input v-validate="'between:0,9|IELTS'" name="IELTSlnRead" v-model="editData.ln_score.IELTS.ln_read" placeholder="R"/>
                          W  :<el-input v-validate="'between:0,9|IELTS'" name="IELTSlnWrite" v-model="editData.ln_score.IELTS.ln_write" placeholder="W"/>
                          S  :<el-input v-validate="'between:0,9|IELTS'" name="IELTSlnSay" v-model="editData.ln_score.IELTS.ln_say" placeholder="S"/>
                          <el-checkbox v-model="isUkiv">是否UKVI</el-checkbox>
                          <div class="check-group">
                            <p><span class="errors" v-if="errors.has('IELTSlnAll')">* {{ errors.first('IELTSlnAll') }}</span></p>
                            <p><span class="errors" v-if="errors.has('IELTSlnListen')">* {{ errors.first('IELTSlnListen') }}</span></p>
                            <p><span class="errors" v-if="errors.has('IELTSlnRead')">* {{ errors.first('IELTSlnRead') }}</span></p>
                            <p><span class="errors" v-if="errors.has('IELTSlnWrite')">* {{ errors.first('IELTSlnWrite') }}</span></p>
                            <p><span class="errors" v-if="errors.has('IELTSlnSay')">* {{ errors.first('IELTSlnSay') }}</span></p>
                          </div>
                        </div>
                        <div class="toefl" v-if="haslanguage('TOEFL')">
                          <span>TOEFL  :</span>
                          <el-input v-validate="'numeric|between:0,120'" name="TOEFLlnAll" v-model="editData.ln_score.TOEFL.ln_all" placeholder="总分"/>
                          L  :<el-input v-validate="'numeric|between:0,30'" name="TOEFLlnListen" v-model="editData.ln_score.TOEFL.ln_listen" placeholder="L"/>
                          R  :<el-input v-validate="'numeric|between:0,30'" name="TOEFLlnRead" v-model="editData.ln_score.TOEFL.ln_read" placeholder="R"/>
                          W  :<el-input v-validate="'numeric|between:0,30'" name="TOEFLlnWrite" v-model="editData.ln_score.TOEFL.ln_write" placeholder="W"/>
                          S  :<el-input v-validate="'numeric|between:0,30'" name="TOEFLlnSay" v-model="editData.ln_score.TOEFL.ln_say" placeholder="S"/>
                          <div class="check-group">
                            <p><span class="errors" v-if="errors.has('TOEFLlnAll')">* {{ errors.first('TOEFLlnAll') }}</span></p>
                            <p><span class="errors" v-if="errors.has('TOEFLlnListen')">* {{ errors.first('TOEFLlnListen') }}</span></p>
                            <p><span class="errors" v-if="errors.has('TOEFLlnRead')">* {{ errors.first('TOEFLlnRead') }}</span></p>
                            <p><span class="errors" v-if="errors.has('TOEFLlnWrite')">* {{ errors.first('TOEFLlnWrite') }}</span></p>
                            <p><span class="errors" v-if="errors.has('TOEFLlnSay')">* {{ errors.first('TOEFLlnSay') }}</span></p>
                          </div>
                        </div>
                      </div>
                      <div class="fenshu" v-if="haslanguage('TOEIC')">
                        <div class="ielts" >
                          <span>TOEIC  :</span>
                          <el-input v-model="editData.ln_score.TOEIC.ln_all" placeholder="总分"/>
                          <span>L  :</span><el-input v-model="editData.ln_score.TOEIC.ln_listen" placeholder="L"/>
                          <span>R  :</span><el-input v-model="editData.ln_score.TOEIC.ln_read" placeholder="R"/>
                          <span>W  :</span><el-input v-model="editData.ln_score.TOEIC.ln_write" placeholder="W"/>
                          <span>S  :</span><el-input v-model="editData.ln_score.TOEIC.ln_say" placeholder="S"/>
                        </div>
                        <div class="toefl sel">
                          <span>CET  :</span>
                          <span>级别</span>
                          <jm-dict-select
                            v-model="editData.ln_score.CET.ln_level"
                            type="online"
                            dict-type="exam_cet"/>
                          <span>成绩:</span>
                          <el-input v-model="editData.ln_score.CET.ln_all" placeholder="分数"/>
                        </div>
                      </div>
                      <div class="fenshu">
                        <div class="ielts aus" v-if="haslanguage('GRE')">
                          <span>GRE  :</span><el-input v-validate="'numeric|between:0,999'" name="GRElnAll" v-model="editData.ln_score.GRE.ln_all"/>
                          <span>数学  :</span><el-input v-validate="'numeric|between:0,999'" name="GRElnRead" v-model="editData.ln_score.GRE.ln_read"/>
                          <span>语文  :</span><el-input v-validate="'numeric|between:0,999'" name="GRElnWrite" v-model="editData.ln_score.GRE.ln_write"/>
                          <span>写作  :</span><el-input v-validate="'numeric|between:0,10'" name="GRElnSay" v-model="editData.ln_score.GRE.ln_say"/>
                          <div class="check-group">
                            <p><span class="errors" v-if="errors.has('GRElnAll')">* {{ errors.first('GRElnAll') }}</span></p>
                            <p><span class="errors" v-if="errors.has('GRElnRead')">* {{ errors.first('GRElnRead') }}</span></p>
                            <p><span class="errors" v-if="errors.has('GRElnWrite')">* {{ errors.first('GRElnWrite') }}</span></p>
                            <p><span class="errors" v-if="errors.has('GRElnSay')">* {{ errors.first('GRElnSay') }}</span></p>
                          </div>
                        </div>
                        <div class="toefl aus" v-if="haslanguage('GMAT')">
                          <span>GMAT  :</span><el-input v-validate="'numeric|between:0,999'" name="GMAT" v-model="editData.ln_score.GMAT.ln_all"/>
                          <div class="check-group">
                            <p><span class="errors" v-if="errors.has('GMAT')">* {{ errors.first('GMAT') }}</span></p>
                          </div>
                        </div>
                        <div class="ielts" style="float: none" v-if="haslanguage('PTE')">
                          <span>PTE  :</span><el-input v-validate="'numeric|between:10,90'" name="PTEall" v-model="editData.ln_score.PTE.ln_all" placeholder="总分"/>
                          L  :<el-input v-validate="'numeric|between:10,90'" name="PTElnListen" v-model="editData.ln_score.PTE.ln_listen" placeholder="L"/>
                          R  :<el-input v-validate="'numeric|between:10,90'" name="PTElnRead" v-model="editData.ln_score.PTE.ln_read" placeholder="R"/>
                          W  :<el-input v-validate="'numeric|between:10,90'" name="PTElnWrite" v-model="editData.ln_score.PTE.ln_write" placeholder="W"/>
                          S  :<el-input v-validate="'numeric|between:10,90'" name="PTElnSay" v-model="editData.ln_score.PTE.ln_say" placeholder="S"/>
                          <div class="check-group">
                            <p><span class="errors" v-if="errors.has('PTEall')">* {{ errors.first('PTEall') }}</span></p>
                            <p><span class="errors" v-if="errors.has('PTElnListen')">* {{ errors.first('PTElnListen') }}</span></p>
                            <p><span class="errors" v-if="errors.has('PTElnRead')">* {{ errors.first('PTElnRead') }}</span></p>
                            <p><span class="errors" v-if="errors.has('PTElnWrite')">* {{ errors.first('PTElnWrite') }}</span></p>
                            <p><span class="errors" v-if="errors.has('PTElnSay')">* {{ errors.first('PTElnSay') }}</span></p>
                          </div>
                        </div>
                      </div>
                      <p
                        class="language"
                        v-if="haslanguage('JLPT')">日语成绩</p>
                      <div class="fenshu" v-if="haslanguage('JLPT')">
                        <div class="toefl sel">
                          <span>JLPT  :</span>
                          <span>级别</span>
                          <jm-dict-select
                            v-model="editData.ln_score.JLPT.ln_level"
                            :filter="item => item.pid === 89"
                            type="online"
                            dict-type="examjp_d"/>
                          <span>成绩:</span>
                          <el-input v-model="editData.ln_score.JLPT.ln_all" placeholder="分数"/>
                        </div>
                        <div class="toefl sel">
                          <span>J-TEST  :</span><span>级别</span>
                          <jm-dict-select
                            v-model="editData.ln_score.JTEST.ln_level"
                            :filter="item => item.pid === 90"
                            type="online"
                            dict-type="examjp_d"/>
                          <span>成绩:</span><el-input v-model="editData.ln_score.JTEST.ln_all" placeholder="分数"/>
                        </div>
                      </div>
                      <div
                        class="fenshu"
                        v-if="haslanguage('NAT')">
                        <div class="toefl sel">
                          <span>NAT  :</span><span>级别</span>
                          <jm-dict-select
                            v-model="editData.ln_score.NAT.ln_level"
                            :filter="item => item.pid === 92"
                            type="online"
                            dict-type="examjp_d"/>
                          <span>成绩:</span><el-input v-model="editData.ln_score.NAT.ln_all" placeholder="分数"/>
                        </div>
                      </div>
                    </div>
                    <div class="textarea">
                      <span>备注:</span>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="editData.beizhu"/>
                    </div>
                    <el-row style="margin-top: 20px">
                      <div class="mes-wapper jm-fl">
                        <span>择校期望时间:</span>
                        <el-date-picker
                          v-model="editData.hope_time"
                          type="date"
                          placeholder="选择日期时间">
                        </el-date-picker>
                      </div>
                      <div class="mes-wapper jm-fl" style="margin-left: 20px">
                        <span>意向专业方向:</span>
                        <el-input
                          size="small"
                          style="height: 36px;"
                          v-model="editData.hope_major"
                          placeholder="请输入内容"/>
                      </div>
                      <div class="mes-wapper jm-fl" style="margin-left: 20px">
                        <span>意向学校:</span>
                        <el-input
                          size="small"
                          style="height: 36px;"
                          v-model="editData.hope_school"
                          placeholder="请输入内容"/>
                      </div>
                    </el-row>
                    <el-row>
                      <div class="textarea" style="margin-top: 20px">
                        <span>特殊沟通说明:</span>
                        <el-input
                          type="textarea"
                          :autosize="{ minRows: 2, maxRows: 4}"
                          v-model="editData.special_remark"
                          placeholder="请输入内容"/>
                      </div>
                    </el-row>
                    <el-row class="jm-tac">
                      <el-button
                        type="primary"
                        :disabled="nouse"
                        v-if="canSave()"
                        @click="saveBasicData()">提交保存</el-button>
                      <el-button @click="syncSchoolInfo">
                        同步毕业院校信息
                      </el-button>
                    </el-row>
                  </div>
                </div>
                <div v-if="activeCountryShow">
                  <div class="tabs-countries" v-if="CountriesInfo&&CountriesInfo.length">
                    <el-tabs v-model="activeCountryName" type="card" @tab-click='countriesClick'>
                      <el-tab-pane v-for="(item,index) in CountriesNames" :key="item.id" >
                        <span slot="label">
                          <i class="tabs-status" v-if="querenArr&&querenArr.length">
                            <jm-dict-select
                              v-model="querenArr[index]"
                              :show="true"
                              type="jiemo"
                              dict-type="is_queren"/>
                        </i>{{ item.name }}</span>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div class="pending" v-if='CountriesInfo&&CountriesInfo.length'>
                    <span>设置预留:</span>
                    <el-select
                      style="width: 100px"
                      size="small"
                      v-model="CountriesInfo[activeCountryTabIndex].pending"
                      placeholder="请选择">
                      <el-option
                        style="text-align: center"
                        v-for="item in pendingData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                    </el-select>
                    <span>
                      <el-button
                        v-if="canSave()"
                        type="success"
                        :disabled="CountriesInfo[activeCountryTabIndex].is_queren === 2 || CountriesInfo[activeCountryTabIndex].is_queren === 4"
                        size="small"
                        class="showing"
                        @click.stop="addAschoolList(activeCountryTabIndex)">添加申请</el-button>
                    </span>
                  </div>
                  <el-collapse
                    v-model="activeNames"
                    class="coll-wapper"
                    v-if="CountriesInfo&&CountriesInfo.length">
                    <!--意向国家的专业信息-->
                    <el-collapse-item
                      v-for="(school, indexSchool) in CountriesInfo[activeCountryTabIndex].school_list"
                      :name='indexSchool'
                      :key="indexSchool"
                    >
                      <template slot="title">
                        <div class="jm-fl">
                          <span :title="school.schoolname+'-'+ school.zhuanye_name">申请{{ indexSchool+1 }}:<span class="applySchool">{{ school.schoolname }}</span>{{ '-'+ school.zhuanye_name }}</span>
                        </div>
                        <div
                          class="jm-fr"
                          style="margin:0 15px;">
                          <el-button
                            type="warning"
                            :disabled="CountriesInfo[activeCountryTabIndex].is_queren === 2 || CountriesInfo[activeCountryTabIndex].is_queren === 4"
                            size="small"
                            v-if="canSave() && aschoolList[activeCountryTabIndex].length > 1"
                            class="showing"
                            @click.stop="$refs.hopes[indexSchool].delSchoolList(school.sh_id ,indexSchool ,school.is_save,activeCountryTabIndex,school.id)">删除</el-button>
                          <el-button
                            v-if="canSave()"
                            type="primary"
                            :disabled="CountriesInfo[activeCountryTabIndex].is_queren === 2 || CountriesInfo[activeCountryTabIndex].is_queren === 4"
                            size="small"
                            class="showing-copy"
                            @click.stop="$refs.hopes[indexSchool].showOtheroffer(true)">复制</el-button>
                        </div>
                      </template>
                      <jm-orderMajor
                        v-if="hackReset"
                        :majormes.sync="school"
                        :index-school='indexSchool'
                        :aschool-list="aschoolList"
                        :sh-country="CountriesInfo[activeCountryTabIndex].shCountry"
                        @chageActiveNames='chageActiveNames'
                        :arry="CountriesInfo[activeCountryTabIndex].school_list"
                        :index-tab="activeCountryTabIndex"
                        ref="hopes"
                        :can-save="canSave()"
                      >
                      </jm-orderMajor>
                    </el-collapse-item>
                  </el-collapse>
                  <div class="footer-btn" v-if="CountriesInfo && CountriesInfo.length">
                    <!--<p>{{ typeof editData.is_queren}}</p>-->
                    <div
                      class="btns-unconfirmed"
                      v-if="canSave()">
                      <el-button
                        type="warning"
                        :disabled="nouse"
                        v-if="checkButton('保存0', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(0)">保存</el-button>
                      <el-button
                        type="warning"
                        :disabled="nouse"
                        v-if="checkButton('保存', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(-CountriesInfo[activeCountryTabIndex].is_queren)">保存</el-button>
                      <el-button
                        type="primary"
                        :disabled="nouse"
                        v-if="checkButton('提交审核', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(5)">提交审核</el-button>
                      <el-button
                        type="primary"
                        :disabled="nouse"
                        v-if="checkButton('提交学生确认', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(1)">提交学生确认</el-button>
                      <el-button
                        type="primary"
                        :disabled="nouse"
                        v-if="checkButton('申请编辑0', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(0)">申请编辑</el-button>
                      <el-button
                        type="primary"
                        :disabled="nouse"
                        v-if="checkButton('申请编辑4', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(4)">申请编辑</el-button>
                      <el-button
                        type="warning"
                        :disabled="nouse"
                        v-if="checkButton('审核通过', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(3)" >审核通过</el-button>
                      <el-button
                        type="danger"
                        :disabled="nouse"
                        v-if="checkButton('驳回2', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(2)">驳回</el-button>
                      <el-button
                        type="danger"
                        :disabled="nouse"
                        v-if="checkButton('驳回6', CountriesInfo[activeCountryTabIndex].is_queren)"
                        @click="saveData(6)">驳回</el-button>
                      <el-button
                        type="success"
                        :disabled="nouse"
                        @click="saveData(-CountriesInfo[activeCountryTabIndex].is_queren, true)">预览择校规划</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="float-cach"
          v-if="editData.has_cache">
          <el-button
            @click="cache()"
            type="primary">加载草稿</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="择校计划单-预览" :visible.sync="offer_review" top="0">
      <iframe :src="this.offer_review_url" width="100%" height="800px"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/fontFace.css';
import student from './student';
import crumbs from '@/components/tool/crumbs';
import basicInformation from '@/components/order/basicInformation';
import language from '@/components/order/languageAchievement';
// import english from '@/components/order/country/englishDepartment';
import orderMajor from '@/components/order/country/order_magor';
import japan from '@/components/order/country/japan';
import school from '@/components/order/school';
import popover from '@/components/order/popoverDuplicate';
import {
  jmSearch,
  jmAreaselect,
  jmChannel,
  jmEducationSelect,
  jmDictSelect
} from '@/components/tool';
import { Validator } from 'vee-validate';

// 择校规划单 单个毕业学校原始数据
let gschools = {
  id: '',
  crm_id: '',
  school: '',
  school_type: '4',
  wangda: '',
  pro_list: [
    {
      id: '',
      school_id: '',
      school: '',
      master_type: 0,
      crm_id: '',
      major: null,
      professional_ower: null,
      gpa_suanshu: '',
      gpa_jiaquan: '',
      gpa_jidian: ''
    }
  ]
};
let schoolData = {
  sh_id: '',
  schoolname: '',
  schoolename: '',
  is_save: false,
  id: '',
  iscan: true,
  offer_id: '',
  crm_id: '',
  userid: '',
  sh_mg_id: '',
  school_name_id: '',
  pf_id: '',
  zhuanye_name: '',
  custom_hope_way: '',
  custom_course: '',
  shenqing_zhuanye: '',
  xuewei_type: '',
  weburl: '',
  zhuyaokecheng: '',
  yuyan: '',
  small_score: '',
  ielts_pro: '',
  xuefei: '',
  toefl_all: '',
  toefl_listen: '',
  toefl_read: '',
  luquyaoqiu: null,
  toefl_say: '',
  toefl_write: '',
  xuezhi: '',
  xuebu: '',
  crios: '',
  chuyuan_year: '',
  chuyuan_month: '',
  shenqing_xuefei: '',
  kaixueqi_year: 0,
  kaixueqi_month: 0,
  shenqingdate: null,
  jieguodate: null,
  shenqing_result: '',
  isshow: 1,
  application_materials: null,
  issee: '',
  established: '',
  is_del: '',
  is_copy: '',
  copy_offer_school_id: '',
  ex1: '',
  ex3: '',
  ex4: '',
  ex5: '',
  update_time: '',
  add_time: '',
  write_step: '',
  backdrop: '',
  is_no_pf: '',
  case_order: '',
  is_offer_img: '',
  offer_img_uptime: '',
  is_recommend: '',
  app_order: ''
};
export default {
  mixins: [student],
  data() {
    return {
      offer_review: false, // 择校规划预览
      offer_review_url: '', // 择校规划预览地址
      CountriesInfo1: [],
      CountriesInfo: [], // 国家列表信息情况
      activeCountryShow: true,
      postOfferBase: {
        crm_id: this.$route.params.id,
      },
      hackReset: false,
      offer_id: null,
      CountriesNames: null,
      activeCountryName: 0,
      activeCountryTabIndex: 0,
      activeNames: [],
      input: '',
      input2: '',
      dialogImageUrl: '',
      dialogVisible: false,
      querenArr: null,
      editData: {
        arts_science: '',
        hope_time: '',
        hope_major: '',
        hope_school: '',
        special_remark: '',
        is_queren: 0,
        group_id: 0,
        ln_score: {
          IELTS: {},
          TOEFL: {},
          TOEIC: {},
          CET: {},
          GRE: {},
          GMAT: {},
          SAT: {},
          ACT: {},
          JTEST: {},
          NAT: {}
        }
      },
      popTitle: '资源ID',
      items: [],
      gschoolList: [gschools], // 毕业学校数据最后再合并
      schoolData: schoolData,
      aschoolList: [], // 申请院校数据 初始化时无论有没有都要保持至少里面有五个
      checked: true,
      radio: '1',
      country: '', // 国家名称
      ds: {},
      mes: '', // 基础信息中 英国是基础 可以添加jp-basic 和aus-basic ''
      mesLang: false, // 语言成绩中是否显示日本特殊字段
      mes3: '英语', // 语言成绩选项 只有两个单独显示为语言 当日本部分出现时显示英语
      which_to_show: 'jm-orderMajor', // 页面加载的时候显示哪个组件 分为英语系列jm-english和日语系列jm-japan
      highestRecord1: '', // 学历
      highestRecord2: '', // 学历学历年级
      education: [], // 学历总集合
      isQueren: '',
      isSave: false, // 控制下方按钮
      experience: false, // 工作经验
      isRadio: '00', // 选中的
      isUkiv: null,
      visible: false,
      educationNum: null,
      neweducationNum: null,
      schoolname: {}, // 目标学校中文名
      ishopeschool: false,
      gogogo: 0,
      pendingData: [
        {
          value: 0,
          label: 0
        },
        {
          value: 1,
          label: 1
        },
        {
          value: 2,
          label: 2
        },
        {
          value: 3,
          label: 3
        },
        {
          value: 4,
          label: 4
        },
        {
          value: 5,
          label: 5
        }
      ],
      pendingDataVal: [],
      iscanSave: true,
      isCache: false,
      nouse: false,
      test: '',
      quern: null
    };
  },
  mounted() {
    this.getDatasource();
    this.getStudent();
    this.yanzhaqngAll();
    this.autoSave();
    this.test = this.$isOnline ? '' : '_test';
  },
  methods: {
    // 同步院校信息
    syncSchoolInfo() {
      if (!this.editData.id) {
        this.$message.error('需要保存择校基础信息后方能同步毕业院校信息');
        return false;
      }
      this.$http._post({
        url: '/index/offer/syncGSchoolInfo',
        data: { crm_id: this.editData.crm_id, offer_id: this.offer_id },
      }).then(() => {
        window.location.reload();
      });
    },
    // 新增院校
    addAschoolList(index) {
      // 目标学校部分新增
      let countryId = this.CountriesInfo[index].country_id;
      let ex2 = '';
      if (countryId === 30 || countryId === 674) {
        ex2 = '一年全日制';
      }
      let aschoolListBase = {
        ex2: ex2,
        country_id: countryId
      };
      Object.assign(aschoolListBase, this.schoolData);
      this.aschoolList[index].push(aschoolListBase);
    },
    chageActiveNames(index) {
      this.activeNames.push(index);
    },
    canSave() {
      return (
        (this.editData.crm_sayer === this.$store.getters.userInfo.userid)
        && !this.$hasPermission([96]))
        || this.$hasPermission([1, 121, 122, 123]);
    },
    jump() {
      this.$nextTick(() => {
        // 报错信息是页面向上滑动
        let distance =
          document.documentElement.scrollTop || document.body.scrollTop;
        let allerr = document.getElementsByClassName('errors');
        let total = this.getOffset(allerr[0]) - 120;
        let newTotal = distance - total;
        let step = newTotal / 50;
        this.smoothUp(distance, total, step);
      });
    },
    smoothUp(distance, total, step) {
      if (distance > total) {
        distance -= step;
        document.body.scrollTop = distance;
        document.documentElement.scrollTop = distance;
        setTimeout(() => this.smoothUp(distance, total, step), 10);
      } else {
        document.body.scrollTop = total;
        document.documentElement.scrollTop = total;
      }
    },
    getOffset(el) {
      const box = el.getBoundingClientRect();
      return (box.top + window.pageYOffset) - document.documentElement.clientTop;
    },
    cache() {
      this.isCache = true;
      this.getStudent();
      this.isCache = false;
      this.$message.success('加载草稿成功');
    },
    jidian(val, oval) {
      let x = val / 25;
      if (oval === '') {
        if (val !== '') {
          this.editData.gpa_jidian = Math.round(x * 100) / 100;
        }
      }
    },
    suanshu(val, oval) {
      let x = val * 25;
      if (oval === '') {
        if (val !== '') {
          this.editData.gpa_suanshu = Math.round(x * 100) / 100;
        }
      }
    },
    gschools() {
      // 新增毕业学校结构
      return {
        id: null,
        crm_id: '',
        school: '',
        school_type: '4',
        wangda: '',
        iscan: true,
        pro_list: [
          {
            id: '',
            school_id: '',
            school: '',
            master_type: 0,
            crm_id: '',
            major: '',
            professional_ower: '',
            gpa_suanshu: '',
            gpa_jiaquan: '',
            gpa_jidian: ''
          }
        ]
      };
    },
    addNewschool() {
      // 新增毕业学校
      this.gschoolList.push(this.gschools());
    },
    haslanguage(name) {
      // 判断显示的语言选型
      let arr = this.editData.ln_score_list;
      //        console.log(arr);
      if (arr && arr.indexOf(name) !== -1) {
        return true;
      }
      return false;
    },
    getStudent() {
      // 用户所有信息
      this.$http
        ._post({
          url: '/index/offer/showInfo',
          data: {
            crm_id: this.$route.params.id,
            is_cache: this.isCache
          }
        })
        .then(({ data }) => {
          if (data.data_type === 'cache') {
            this.editData = data.editData;
            this.CountriesInfo = data.CountriesInfo;
            return;
          }
          this.offer_id = data.id;
          this.postOfferBase.offer_id = data.id;
          this.postOfferBase.userid = data.userid;
          Object.values(data.ln_score).forEach((item) => {
            // 重置为0
            if (item.ln_all === 0) {
              item.ln_all = '';
            }
            if (item.ln_listen === 0) {
              item.ln_listen = '';
            }
            if (item.ln_read === 0) {
              item.ln_read = '';
            }
            if (item.ln_say === 0) {
              item.ln_say = '';
            }
            if (item.ln_write === 0) {
              item.ln_write = '';
            }
          });
          if (data.work_is === 1) {
            // 工作年限
            this.experience = true;
          } else {
            this.experience = false;
          }
          if (data.isukvi === 1) {
            // 是否ukvi
            this.isUkiv = true;
          } else {
            this.isUkiv = false;
          }
          this.editData = data;
          if (!this.editData.position) {
            this.$set(this.editData, 'position', '');
          }
          if (!this.editData.work_year) {
            this.$set(this.editData, 'work_year', '');
          }
          if (!this.editData.arts_science) {
            this.$set(this.editData, 'arts_science', '');
          }
          this.quern = this.editData.is_queren;
          // 初始化优先选择GPA 并且重置0
          // let indexs = 0;
          // this.editData.g_school_list.forEach((itemA, index) => {
          //   if (itemA.pro_list) {
          //     itemA.pro_list.forEach((itemB, indexB) => {
          //       if (
          //         itemB.gpa_jiaquan === this.editData.gpa_jiaquan &&
          //         itemB.gpa_jidian === this.editData.gpa_jidian &&
          //         itemB.gpa_suanshu === this.editData.gpa_suanshu &&
          //         indexs === 0
          //       ) {
          //         this.isRadio = `${index}${indexB}`;
          //         indexs++;
          //       }
          //       if (itemB.gpa_jiaquan === 0) {
          //         itemB.gpa_jiaquan = '';
          //       }
          //       if (itemB.gpa_jidian === 0) {
          //         itemB.gpa_jidian = '';
          //       }
          //       if (itemB.gpa_suanshu === 0) {
          //         itemB.gpa_suanshu = '';
          //       }
          //     });
          //   }
          // });
          if (this.editData.g_school_list && this.editData.g_school_list.length) {
            this.editData.g_school_list.forEach((item, idx) => {
              if (item.pro_list) {
                item.pro_list.forEach((proItem, proIdx) => {
                  if (proItem.use_status === 1) {
                    this.isRadio = `${idx}${proIdx}`;
                  }
                });
              }
            });
          }
          // 重置总的GPA冲击
          if (this.editData.gpa_jiaquan === 0) {
            this.editData.gpa_jiaquan = '';
          }
          if (this.editData.gpa_jidian === 0) {
            this.editData.gpa_jidian = '';
          }
          if (this.editData.gpa_suanshu === 0) {
            this.editData.gpa_suanshu = '';
          }
          // 设置显示学生状态
          this.showLanguage();
          // 初始化毕业学校
          if (this.editData.g_school_list.length !== 0) {
            this.gschoolList = this.editData.g_school_list;
            this.gschoolList.forEach((item) => {
              this.$set(item, 'iscan', true);
              if (!item.pro_list) {
                this.$set(item, 'pro_list', this.createGschoolPro());
              }
            });
          }
          // 设置目标学校 并添加字段
          // data.school_list.forEach((item) => {
          //   item.data.forEach((itemA) => {
          //     this.$set(itemA, 'iscan', true);
          //   });
          // });
          this.yanzhaqngAll();
          if (!data.id) {
            this.activeCountryShow = false;
          }
          this.getCountriesNames();
        });
    },
    saveData(num, ex) {
      let tabIndex = this.activeCountryTabIndex;
      this.nouse = true;
      const allCheck = [];
      this.$refs.hopes.forEach((item) => {
        allCheck.push(item.checkout());
      });
      Promise.all(allCheck).then((results) => {
        let chooseOne = 0;
        this.activeNames = [];
        this.aschoolList[tabIndex].forEach((item, index) => {
          if (this.CountriesInfo[tabIndex].is_queren >= 1 && !item.iscan && chooseOne === 0) {
            this.activeNames.push(index);
            this.iscanSave = item.iscan;
            this.$message.error(`申请学校${index + 1}下的数据不全`);
            chooseOne++;
          }
        });
        // 待提交状态不验证
        if (this.CountriesInfo[tabIndex].is_queren >= 1 && results.some(r => r === false)) {
          // 向上滑动
          this.jump();
          this.nouse = false;
          return;
        }
        this.CountriesInfo[tabIndex].is_queren = num;
        // 是否 预览
        this.$set(this.CountriesInfo[tabIndex], 'is_review', ex);
        // 请求
        this.$http
          ._post({
            url: '/index/offer/editCountry',
            data: { ...this.CountriesInfo[tabIndex], ...this.postOfferBase }
          })
          .then((data) => {
            if (data.data.error !== '') {
              this.$message.error(data.data.error);
            } else {
              if (data.data.url) {
                this.offer_review = true;
                this.offer_review_url = data.data.url;
              }
              this.$message.success('保存成功');
              this.getCountriesNames(tabIndex);
            }
            this.nouse = false;
          })
          .catch(() => {
            this.$message.error('服务端失败');
          });
      });
      this.iscanSave = true;
    },
    autoSave() {
      setInterval(() => this.setTimeSave(), 180000);
    },
    setTimeSave() {
      // 自动缓存借口
      if (this.editData.custom_education > 4) {
        Object.keys(this.gschoolList).forEach((v) => {
          let item = this.gschoolList[v];
          Object.keys(item.pro_list).forEach((vv) => {
            if (item.pro_list[vv].gpa_suanshu) {
              this.editData.gpa_suanshu = item.pro_list[vv].gpa_suanshu;
              this.editData.gpa_jiaquan = item.pro_list[vv].gpa_jiaquan;
              this.editData.gpa_jidian = item.pro_list[vv].gpa_jidian;
            }
          });
        });
      }
      this.editData.g_school_list = this.gschoolList;
      this.editData.edit_time = Date.parse(new Date()) / 1000;
      let autoCacheData = {
        editData: this.editData,
        CountriesInfo: this.CountriesInfo
      };
      this.$http
        ._post({
          url: '/index/offer/autoCache',
          data: autoCacheData
        })
        .then(() => {
          this.$message.success('草稿已经自动缓存');
        });
    },
    createLanguage() {
      // 各个国家语言成绩的初始化
      return {
        ln_id: '',
        user_id: '',
        ln_level: '',
        ln_country: '',
        ln_type: '',
        ln_listen: '',
        ln_say: '',
        ln_read: '',
        ln_write: '',
        ln_all: '',
        crm_id: ''
      };
    },
    createGschoolPro() {
      // 毕业学校专业信息初始化
      return [
        {
          id: '',
          school_id: '',
          school: '',
          master_type: '',
          crm_id: '',
          major: '',
          professional_ower: '',
          gpa_suanshu: '',
          gpa_jiaquan: '',
          gpa_jidian: ''
        }
      ];
    },
    showLanguage() {
      // ln_score为空 手动初始化语言成绩选项
      let a = {};

      this.editData.ln_score_list.forEach((item) => {
        if (!this.editData.ln_score[item]) {
          this.$set(a, item, this.createLanguage());
        } else {
          this.$set(a, item, this.editData.ln_score[item]);
        }
      });
      this.editData.ln_score = a;
    },
    checkIsFive(arr, id) {
      let ex2 = '';
      if (id === 30 || id === 674) {
        ex2 = '一年全日制';
      }
      // 当给出的下方学校数据小与5的时候手动不全 并且做出相应的cnAnden
      arr.forEach((item) => {
        let forLength = 5 - item.length;
        if (forLength > 0) {
          for (let i = 0; i < forLength; i++) {
            let aschoolListBase = {
              ex2: ex2,
              country_id: id
            };
            Object.assign(aschoolListBase, this.schoolData);
            item.push(aschoolListBase);
          }
        }
      });
    },
    yanzhaqngAll() {
      // 本页验证信息方法
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => {
              return `请输入${field}`;
            },
            between: (filed, data) => {
              return `${filed}应该在${data[0]} 到 ${data[1]}之间`;
            },
            numeric: (filed) => {
              return `${filed}只能为数字`;
            }
          },
          attributes: {
            highGschool: '毕业学校',
            stuname: '学生姓名',
            customEducation: '学历',
            xueliBz: '学历备注',
            IELTSlnAll: 'IELTS总分',
            IELTSlnListen: 'IELTS听力',
            IELTSlnRead: 'IELTS阅读',
            IELTSlnWrite: 'IELTS写作',
            IELTSlnSay: 'IELTS口语',
            TOEFLlnAll: 'TOEFL总分',
            TOEFLlnListen: 'TOEFL听力',
            TOEFLlnRead: 'TOEFL阅读',
            TOEFLlnWrite: 'TOEFL写作',
            TOEFLlnSay: 'TOEFL口语',
            GRElnAll: 'GRE总分',
            GRElnRead: '数学',
            GRElnWrite: '语文',
            GRElnSay: '写作',
            GMAT: 'GMAT总分',
            allsuanshu: '算数平均分',
            alljiaquan: '加权平均分',
            alljidian: '绩点',
            PTEall: 'PTE总分',
            PTElnListen: 'PTE听力',
            PTElnRead: 'PTE阅读',
            PTElnWrite: 'PTE写作',
            PTElnSay: 'PTE口语',
            ...this.schoolname
          }
        }
      };
      Validator.localize(dictionary);
    },
    // 获取国家字典
    getCountryDict() {
      let countries = this.ds.country;
      return countries;
    },
    // 获取基本信息
    async getBasicData(id) {
      return this.$http
        ._post({
          url: '/index/offer/showCountryOfferSchoolList',
          data: {
            country_id: id,
            ...this.postOfferBase
          }
        });
    },
    // 国家处理
    getCountriesNames(tabIndex = null) {
      let countries = [];
      if (tabIndex !== null) {
        let countryId = this.CountriesNames[tabIndex].id;
        this.getBasicData(countryId).then(({ data }) => {
          this.$set(this.CountriesInfo, tabIndex, data);
          this.$set(this.querenArr, tabIndex, data.is_queren);
          this.$set(this.aschoolList, tabIndex, data.school_list);
          this.checkIsFive(this.aschoolList, data.country_id);
        });
        return;
      }
      this.CountriesInfo = [];
      this.querenArr = [];
      // 国家字典
      let arrDict = [];
      this.editData.custom_active_country.forEach((item) => {
        this.getBasicData(Number(item))
          .then(({ data }) => {
            arrDict.push(data);
            if (arrDict.length === this.editData.custom_active_country.length) {
              // 排序
              this.getCountryDict().forEach((itemCountry) => {
                arrDict.forEach((itemArr) => {
                  if (itemCountry.id === itemArr.country_id) {
                    this.CountriesInfo.push(itemArr);
                    countries.push({ name: itemCountry.value, id: itemCountry.id });
                    this.querenArr.push(itemArr.is_queren);
                    this.aschoolList.push(itemArr.school_list);
                    // 设置最小五个目标学校
                    this.checkIsFive(this.aschoolList, itemCountry.id);
                  }
                });
              });
              this.$nextTick(() => {
                this.hackReset = true;
              });
            }
          });
      });
      this.CountriesNames = countries;
      // this.recurTest(0, Object.values(this.CountriesNames).length);
    },
    // recurTest(j, length) {
    //   this.getBasicData(Number(Object.values(this.CountriesNames)[j].id))
    //     .then(({ data }) => {
    //       this.CountriesInfo.push({ ...data, });
    //       this.querenArr.push(data.is_queren);
    //       this.aschoolList.push(data.school_list);
    //       // 设置最小五个目标学校
    //       this.checkIsFive(this.aschoolList, Number(Object.values(this.CountriesNames)[j].id));
    //       if (++j < length) {
    //         this.recurTest(j, length);
    //       }
    //     });
    // },
    // 标签页切换
    countriesClick(tab) {
      this.hackReset = false;
      this.activeCountryTabIndex = tab.paneName;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    },
    // 保存基本信息
    saveBasicData() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.iscanSave = result;
          this.$message.error('数据不全');
        }
        if (this.editData.custom_education <= 4) {
          if (
            this.editData.gpa_suanshu === '' &&
              this.editData.gpa_jiaquan === '' &&
              this.editData.gpa_jidian === ''
          ) {
            this.iscanSave = false;
            this.$message.error('数据不全');
          }
        }
      });


      this.nouse = true;
      this.$http
        ._post({
          url: '/index/offer/edit',
          data: this.editData
        }).then((data) => {
          if (data.data.error !== '') {
            this.$message.error(data.data.error);
          } else {
            if (data.data.url) {
              window.open(data.data.url);
            }
            this.$message.success('保存成功');
            this.getStudent();
          }
          this.nouse = false;
        });
    },
    checkButton (key, isQueren) {
      let rs = false;
      if (this.nouse) {
        return rs;
      }
      switch (key) {
        case '保存0':
          if (isQueren === 0) {
            rs = true;
          }
          break;
        case '保存':
          if ([6].indexOf(isQueren) !== -1) {
            rs = true;
          // } else if ([1].indexOf(isQueren) !== -1 && this.$hasPermission('review_-1')) {
          //   rs = true;
          }
          break;
        case '提交审核':
          if ([0, 2, 6].indexOf(isQueren) !== -1) {
            rs = true;
          }
          break;
        case '提交学生确认':
          if ([5].indexOf(isQueren) !== -1 && this.$hasPermission('review_-1')) {
            rs = true;
          }
          break;
        // case '驳回2':
        //   if ([4].indexOf(isQueren) !== -1 && this.$hasPermission('review_-1')) {
        //     rs = true;
        //   }
        //   break;
        case '驳回6':
          if ([5].indexOf(isQueren) !== -1 && this.$hasPermission('review_-1')) {
            rs = true;
          }
          break;
        case '申请编辑0':
          if ([1].indexOf(isQueren) !== -1) {
            rs = true;
          }
          break;
        // case '申请编辑4':
        //   if ([2].indexOf(isQueren) !== -1) {
        //     rs = true;
        //   }
        //   break;
        // case '审核通过':
        //   if ([4].indexOf(isQueren) !== -1 && this.$hasPermission('review_-1')) {
        //     rs = true;
        //   }
        //   break;
        default:
      }
      return rs;
    }
  },
  computed: {
    // permissions() {
    //   // 权限
    //   return `review_${this.editData.group_id}`;
    // },
  },
  watch: {
    isGschool(v) {
      if (!v) {
        this.iscanSave = false;
      }
    },
    isRadio(val) {
      let arr = val.split('');
      this.gschoolList.forEach((item) => {
        item.pro_list.forEach((proItem) => {
          proItem.use_status = 0;
        });
      });
      this.gschoolList[arr[0]].pro_list[arr[1]].use_status = 1;
    },
    experience(val) {
      // 工作经验
      if (val) {
        this.editData.work_is = 1;
      } else {
        this.editData.work_is = 2;
      }
    },
    isUkiv(val) {
      // 是否ukvi
      if (val) {
        this.editData.isukvi = 1;
      } else {
        this.editData.isukvi = 2;
      }
    },
    'editData.custom_education'(val, Oldval) {
      if (val !== Oldval) {
        this.educationNum = Oldval;
        this.neweducationNum = val;
      }
      //        console.log(this.educationNum, this.neweducationNum);
      this.$validator.validate('customEducation');
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-basicInformation': basicInformation,
    'jm-language': language,
    'jm-japan': japan,
    'jm-school': school,
    'jm-popover': popover,
    'jm-orderMajor': orderMajor,
    jmAreaselect,
    jmChannel,
    jmEducationSelect,
    jmDictSelect,
    jmSearch,
    Validator
  },
  created() {
    Validator.extend('customEducation', {
      getMessage: (field) => {
        return `请输入${field}`;
      },
      validate: () => {
        return this.editData.custom_education !== '';
      }
    });
    Validator.extend('IELTS', {
      // IELTS 小数点一位切必须是.5
      getMessage: (field) => {
        return `${field}保留一位且.5`;
      },
      validate: (value) => {
        if (value % 1 !== 0) {
          let nVal = String(value).split('.');
          return nVal[1].length === 1 && nVal[1] === '5';
        }
        return true;
      }
    });
  }
};
</script>
<style lang="less" >
.tabs-countries .el-tabs__item{
  min-width: 130px;
  padding: 0 !important;
  height: 50px;
  span{
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    line-height: 50px;
    text-align: center;
    .tabs-status{
      width: auto;
      height: 15px;
      line-height: 15px;
      background: #fff;
      display: block;
      position: absolute;
      right: 8px;
      top: 0;
      font-size: 12px;
      color: red;
      span{
        line-height: 15px;
      }
    }
  }
}
.tabs-countries .is-active{
  background: #409EFF;
  color: #fff;
}
</style>
<style>
.submit-save{
  margin:15px auto;
  display: block;
}
.lookHis {
  display: block;
  height: 100%;
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  padding: 0 10px;
  line-height: 50px;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 10px;
}
.float-cach {
  position: fixed;
  z-index: 500;
  left: 5px;
  bottom: 50px;
}
.coll-wapper .showMes:nth-last-of-type(1) {
  margin-right: 10px;
}
.showMes {
  background: url(../../assets/images/curry.png);
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
}
.pending {
  padding-bottom: 10px;
}
.pending .el-input__inner {
  text-align: center;
}
.prompting-wapper {
  height: 55px;
}
.ipt:after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
}
.errors {
  color: red;
}
.form-lable-wappers > div {
  margin: 0 !important;
}
.form-lable > div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
  margin-top: 10px !important;
}
.ipt {
  padding-top: 5px;
  padding-bottom: 3px;
}
.form-lable > div span {
  white-space: nowrap;
  margin-right: 4px;
}
.jm-input100 {
  width: 100% !important;
}
.jm-input230 {
  width: 300px !important;
}
.textarea span {
  font-size: 16px;
}
.textarea > div {
  margin-top: 5px;
  margin-bottom: 10px;
}
.order-state > div span {
  background: #fff;
  border-radius: 8px;
  padding: 6px;
  line-height: 30px;
  color: red;
}
.state1 {
  color: #ff3f3f;
}
.upload {
  margin-bottom: 20px;
}
.professional .el-collapse {
  border: none;
}
.professional .el-collapse-item .el-collapse-item__header {
  background: transparent !important;
  border: none;
  padding: 0;
}
.professional
  .el-collapse-item
  .el-collapse-item__header
  > .el-collapse-item__header__arrow {
  display: none;
}
.coll-wapper div:hover .showing {
  display: inline-block;
}
.professional .showing1 {
  display: none;
}
.professional .showing-copy{
    margin: 10px auto 10px 10px;
}
.professional:hover .showing1 {
  display: inline-block;
}
.main-right {
  width: auto;
}
.aus-basic label {
  display: flex;
  justify-content: center;
  align-items: center;
}
.information {
  width: 100%;
  /* background: #f3f3f3; */
}
.information:after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
  height: 0;
}
.information-left {
  float: left;
  width: 180px;
  height: 100%;
}
.information-right {
  float: left;
  width: calc(100% - 200px);
  height: 100%;
}
.information-right i {
  margin-top: 3px;
  margin-right: 10px;
  font-size: 13px;
  float: left;
}
.information-right > div {
  float: right;
}
.basic-title {
  cursor: default;
  box-sizing: content-box;
}
.basic-title:after {
  display: block;
  clear: both;
  opacity: 0;
}
.tit-wapper {
  width: 100%;
  height: 40px;
  background: #01142d;
  line-height: 40px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 10px;
  margin-right: 20px;
}
.ipt {
  width: 100%;
  align-items: center;
  border-bottom: 1px dashed #b8c4ce;
}
.annotation {
  color: #ff3f3f;
}
.school-mes {
  height: 60px;
}
.school-mes button {
  margin-left: 12px;
}
.school-mes:after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
}
.sp {
  border: none;
}
.add > div:nth-of-type(1) {
  display: flex;
  align-items: center;
  margin-top: 15px;
  justify-content: center;
  margin-bottom: 10px;
}
.add {
  border: none;
}
.add > div {
  width: 100%;
}
.fenshu {
  margin-bottom: 16px;
}
.fenshu > div {
  width: 510px;
  float: left;
  padding-bottom: 4px;
}
.fenshu:after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
}
.fenshu .aus {
  margin-bottom: 16px;
}
.fenshu > div > div {
  max-width: 50px;
  margin-left: 4px;
}
.fenshu > div input {
  text-align: center;
}
.ielts {
  height: 100%;
  margin-right: 20px;
}
.toefl {
  height: 100%;
}
.fenshu > div > div:nth-of-type(1) {
  max-width: 74px;
}
.fenshu > .aus > div {
  max-width: 60px;
}
.fenshu > .aus > div:nth-of-type(1) {
  max-width: 60px;
}
.apply-school > div:after {
  display: block;
  content: "";
  clear: both;
  opacity: 0;
}
.editUnivName {
  width: 100%;
  margin: 10px 0;
}
.editUnivName:after {
  display: block;
  content: "";
  opacity: 0;
  visibility: hidden;
  clear: both;
  height: 0;
}
.editUnivName span {
  display: block;
  padding: 0 4px;
  padding-left: 4px;
  white-space: nowrap;
}
.editUnivName > div {
  width: 48%;
  float: left;
  box-sizing: border-box;
  display: flex;
  margin: 0 8px;
  align-items: center;
  box-sizing: border-box;
  border-radius: 4px;
}
.discName {
  height: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.discTitle {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-around;
  color: #48576a;
  cursor: pointer;
  width: 100%;
}
.inputWrap {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border-radius: 4px;
  float: left;
  margin: 8px;
}
.apply-school span {
  padding: 0 4px;
  white-space: nowrap;
}
.apply-school input {
  text-align: left;
}
.degreeType > div > div {
  max-width: 500px;
}
.inter > .inputWrap > div {
  max-width: 100%;
}
.gpa-span {
  margin-right: 5px;
}
.gpa > div:nth-of-type(1) {
  margin-bottom: 20px;
}
.gpa > div:nth-of-type(2) > div > div {
  width: 200px;
}
.result {
  margin-bottom: 40px;
}
.result span {
  padding: 4px 10px;
}
.btns-unconfirmed {
  display: flex;
  justify-content: center;
  padding: 50px;
}
.btns-confirmed {
  display: flex;
  justify-content: center;
  padding: 50px;
}
.fenshu > .sel > div:nth-of-type(1) {
  max-width: none;
}
.fenshu .sel > div > div {
  max-width: 120px;
}
.language {
  text-indent: 10px;
  margin-bottom: 20px;
}
.professional {
  padding-bottom: 10x;
}
.table-agile-info .el-collapse-item__header {
  background-color: #01142d !important;
}
.ipt-wapper .el-input--small .el-input__inner {
  height: 36px;
}
.highSchool {
  padding: 5px 0 1px 0;
  position: relative;
}
.highSchool:after {
  display: block;
  clear: both;
  opacity: 0;
  content: "";
}
.readonly-info-wrap input[readonly="readonly"]{
  border: none;
  padding: 0;
}
.gpaTips{
  margin-left:20px;
}
.gpaTips p{
  white-space: pre;
}
.check-group p {
  float: left;
  white-space: pre;
}
</style>
<style scoped>
.float {
  width: 100%;
  height: 120px;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
.float p {
  text-align: center;
  line-height: 120px;
  color: red;
  font-size: 16px;
}
.el-row .el-col{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 55px;
  padding:0 8px;
  border-right: solid 1px #f1f5ff;
  border-bottom: solid 1px #f1f5ff;
  font-size: 12px;
}
.el-row .el-col-1, .el-row .el-col-2 {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding-right: 5px;
  padding-left: 0;
  font-size: 14px;
  color: #010D2D;
  font-weight: bold;
  text-align: right;
}

</style>
